import { isArray } from 'lodash';
import { string } from 'prop-types';

export function getTotalMoney(money = []) {
	if (isArray(money)) {
		return money?.reduce(
			(accumulator, currentValue) =>
				accumulator + Number(currentValue?.amount) * Number(currentValue?.count) || 0,
			0
		);
	}

	return 0;
}

// eslint-disable-next-line sonarjs/cognitive-complexity
export function onAction(money = [], data = {}, type = string, value = string) {
	let moneyArray = money;

	if (isArray(money)) {
		switch (type) {
			case 'plus':
				moneyArray =
					money?.map((item) =>
						item?.money_id === data?.money_id
							? { ...item, count: Number(item.count) + 1 }
							: item
					) || [];
				break;
			case 'minus':
				moneyArray =
					money?.map((item) =>
						item?.money_id === data?.money_id
							? { ...item, count: Number(item.count) - 1 }
							: item
					) || [];
				break;
			case 'count_update':
				moneyArray =
					money?.map((item) =>
						item?.money_id === data?.money_id && value > -1
							? { ...item, count: Number(value) }
							: item
					) || [];
				break;
			default:
				return moneyArray;
		}
	}

	return moneyArray;
}
